import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { Provider } from 'react-redux';
import configureStore from './store';
import 'bootstrap/dist/css/bootstrap.css';
import { QueryClient, QueryClientProvider } from 'react-query';

const store = configureStore();
const queryClient = new QueryClient();

ReactDOM.render(
  <Provider store={store}>
    {/* <React.StrictMode> */}
    <QueryClientProvider client={queryClient}>
       <App />
    </QueryClientProvider>
    {/* </React.StrictMode> */}
  </Provider>,

  document.getElementById('root')
);
reportWebVitals();
